// Tabs.jsx
import React, { useState } from 'react'

export const Tabs = ({ setValueTabsSort, itemsType }) => {
    const [currentIndex, setCurrentIndex] = useState(1)

    const renderTabsItems = () => {
        let content

        switch (itemsType) {
            case 'main':
                content = [
                    { value: 'all', text: 'Основное' },
                    { value: 'analytics', text: 'Аналитика' },
                ]
                break

            case 'application':
                content = [
                    { value: 'all', text: 'Все' },
                    { value: 'ordered', text: 'Оформленые' },
                    { value: 'processing', text: 'На рассмотрении' },
                    { value: 'confirmed', text: 'Подтвержденные' },
                    { value: 'rejected', text: 'Отклоненные' },
                ]
                break

            case 'products':
                content = [
                    { value: 'all', text: 'Все' },
                    { value: 'nothing', text: 'Ничего' },
                    { value: 'inProgress', text: 'В работе' },
                    { value: 'modelReady', text: 'Модель готова' },
                    { value: 'productInfo', text: 'Инфо по товару' },
                    { value: 'photosUploaded', text: 'Фото загружены' },
                ]
                break

            case 'adminBilling':
                content = [
                    { value: 'promos', text: 'Справочник Промокодов' },
                    { value: 'transactions', text: 'Все Транзакции' },
                ]
                break

            default:
                content = [
                    { value: 'all', text: 'Все' },
                    { value: 'ordered', text: 'Новые' },
                    { value: 'confirmed', text: 'Подтвержденные' },
                    { value: 'work', text: 'Производство' },
                    { value: 'shipped', text: 'Передан в службу доставки' },
                    { value: 'delivered', text: 'Доставленные' },
                ]
        }

        return content
    }

    const handleValueSort = (value) => {
        if (typeof setValueTabsSort === 'function') {
            setValueTabsSort(value)
        }
    }

    return (
        <div className="tabs">
            <div className="tabs__container">
                <div className="tabs__list">
                    {renderTabsItems().map((item, index) => (
                        <div
                            className={currentIndex === index + 1 ? 'tabs__item active' : 'tabs__item'}
                            onClick={() => {
                                setCurrentIndex(index + 1)
                                handleValueSort(item.value)
                            }}
                            key={item.value}
                        >
                            <div className="tabs__link">{item.text}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}